// extracted by mini-css-extract-plugin
export default {"container":"NewClaim_container__KZwv6","promptBox":"NewClaim_promptBox__kp1tW","heading":"NewClaim_heading__-X2WL","title":"NewClaim_title__01rVs"};